import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/cascade';

import { StackingContext } from 'utils/ui-helpers/stackingContexts';

const useStyles = createUseStyles({
  gridImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 1,
    position: 'absolute',
  },
  resizeItemContainer: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    top: Spacings.s0,
    left: Spacings.s0,
  },
  resizeItem: {
    width: (props => `${(!props.isMaxWidth ? props.scale : 1) * 100}%`),
    height: (props => `${(props.isMaxWidth ? props.scale : 1) * 100}%`),
    position: 'relative',
    background: (props => props.resizeParams.width && props.resizeParams.height && props.bgColor && props.bgColor !== 'transparent' ? props.bgColor : 'var(--transparent-background-image)'),
  },
  titleContainer: {
    position: 'absolute',
    display: 'flex',
    width: '100%',
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
    bottom: Spacings.s0,
    zIndex: StackingContext.Base,
    backgroundColor: 'rgb(84, 88, 105, .7)',
  },
  sizeTitle: {
    fontWeight: 600,
    fontSize: 10,
    lineHeight: 1,
    color: 'rgba(255, 255, 255)',
  },
  resizeImg: {
    objectFit: (props => (props.resizeParams.usePadding ? 'contain' : 'fill')),
    width: '100%',
    height: '100%',
    zIndex: 2,
    position: 'absolute',
  },
});

export default useStyles;
